import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '../../../../../DeviationViews/Dumbo';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './ChooseAvatarDumbo.scss';

export interface Props {
  /** The deviation to display as an avatar */
  deviation: PapiDeviation;
  /** Additional CSS class */
  className?: string;
  /** Whether the avatar is selected */
  selected?: boolean;
  /** Click handler */
  onClick?: () => void;
}

/**
 * Large exclusive avatar component that displays a deviation thumbnail
 * Used for avatar selection in comment modals
 */
const ChooseAvatarDumbo: React.FC<Props> = ({
  deviation,
  className,
  selected,
  onClick,
}) => {
  const isMobile = useContext(MobileContext);

  return (
    <div
      className={`${s['dumbo-avatar']} ${selected ? s['selected'] : ''} ${className || ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <DeviationDumbView
        deviation={deviation}
        width={isMobile ? 92 : 72}
        height={isMobile ? 92 : 72}
        allowPreviewUsage={true}
        useBackgroundColor={true}
        greenLikeCrop={true}
      />
    </div>
  );
};

ChooseAvatarDumbo.displayName = 'ChooseAvatarDumbo';

export default ChooseAvatarDumbo;
